module.exports = __webpack_public_path__ + "static/media/07.32eb49b3.jpg";